/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-alert */
import moment from 'moment';
// eslint-disable-next-line import/no-unresolved, import/extensions
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
} from 'react-share';
import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved, import/extensions
import { Navigation, Pagination } from 'swiper/modules';
import Link from '../../components/Link';
import {
  NewsSideList,
  ImageLightbox,
  AdFixSection,
} from '../../components/Widget';
import s from './NewsRead.css';
import { COMPANY_FILTERS } from '../../webconfig';

function splitContent(text, token) {
  const positionOfToken = text.indexOf(token, text.length / 2);
  const endOfTokenPosition = positionOfToken + token.length;
  const finals = [
    text.substring(0, endOfTokenPosition),
    text.substring(endOfTokenPosition, text.length),
  ];
  return finals;
}

class NewsRead extends React.Component {
  static propTypes = {
    article: PropTypes.object.isRequired,
    allNews: PropTypes.arrayOf(PropTypes.object).isRequired,
    pathname: PropTypes.string.isRequired,
    publication: PropTypes.object.isRequired,
    // fetch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state.adsLeft = 0;
    this.handleResize = this.handleResize.bind(this);
  }

  state = {
    lightboxImgUrl: null,
  };

  componentDidMount() {
    this.initSwiper();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.article !== this.props.article) {
      this.destroySwiper();
      this.initSwiper();
    }
  }

  componentWillUnmount() {
    this.destroySwiper();
    window.removeEventListener('resize', this.handleResize);
  }

  // eslint-disable-next-line react/sort-comp
  initSwiper() {
    const el = document.getElementById('news-read-carousel');
    if (!el) return;
    this.swiper = new Swiper(el, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: '#news-read-carousel .swiper-button-next',
        prevEl: '#news-read-carousel .swiper-button-prev',
      },
      pagination: {
        el: '#news-read-carousel .swiper-pagination',
        clickable: true,
      },
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  onCopied() {
    alert('Successfully copied article link. Share this anywhere!');
  }

  getSuffix(key) {
    const lastChar = key.charAt(key.length - 1);
    // eslint-disable-next-line no-restricted-globals
    return isNaN(lastChar) ? '' : `_${lastChar}`;
  }

  // updateNewsCount(newStuff, fetch) {
  //   const mutationString = createMutation(newStuff, 'updateNewsCount');
  //   // console.log(mutationString);
  //   fetch('/graphql', {
  //     body: JSON.stringify({
  //       query: mutationString,
  //     }),
  //   }).then(resp => {
  //     resp.json().then(() => {
  //       // DO NOTHING
  //     });
  //   });
  // }

  // extract keys by convention and return array
  generateArrayOfImagesAndCaptions() {
    const inputArticle = this.props.article;
    const IMAGE_PREFIX = 'article_image_uid';
    const CAPTION_PREFIX = 'article_image_caption';
    const imageKeys = Object.keys(inputArticle).filter(
      it => it.indexOf(IMAGE_PREFIX) > -1 && inputArticle[it],
    );

    const list = [];

    imageKeys.forEach(imageKey => {
      list.push({
        image: inputArticle[imageKey],
        caption: inputArticle[`${CAPTION_PREFIX}${this.getSuffix(imageKey)}`],
      });
    });

    return list;
  }

  handleShowImgLightbox(imgUrl) {
    this.setState({
      lightboxImgUrl: imgUrl,
    });
  }

  handleCloseImgLightbox() {
    this.setState({
      lightboxImgUrl: null,
    });
  }

  handleResize() {
    let adsLeft = 0;
    const banner = document.querySelector('.banner');
    const bannerWidth = banner ? banner.offsetWidth : 0;
    if (window.innerWidth >= 1200)
      adsLeft = (window.innerWidth * 0.7 - bannerWidth) / 2;

    this.setState({ adsLeft });
  }

  // eslint-disable-next-line react/sort-comp
  renderCarouselItem(item) {
    const imgSrc =
      item && item.image && item.image.indexOf('https') === -1
        ? `https://dxfpracgmlczp.cloudfront.net/${item.image}`
        : item.image;
    return (
      <div>
        <div className={s.imageContainer}>
          {/* <div className="custom-latest-news-list-item" key={`news-list-item-${idx}`}> */}
          <img
            alt="carousel-item"
            src={imgSrc}
            className={s.articleImage}
            role="presentation"
            onClick={() => this.handleShowImgLightbox(imgSrc)}
          />
        </div>
        {item.caption ? (
          <div className={s.imageCaption}>{item.caption}</div>
        ) : (
          <span />
        )}
      </div>
    );
  }

  renderNewsListCarouselSection() {
    const items = this.generateArrayOfImagesAndCaptions();

    return (
      <div className="swiper" id="news-read-carousel">
        <div className="swiper-wrapper">
          {items.map(
            (item, idx) =>
              item && (
                <div className="swiper-slide" key={`carousel-${idx}`}>
                  {this.renderCarouselItem(item)}
                </div>
              ),
          )}
        </div>
        <div className="swiper-button-prev" />
        <div className="swiper-button-next" />
        <div className="swiper-pagination" />
      </div>
    );
  }

  renderTagLinks(tagString) {
    if (tagString !== null) {
      const tags = tagString.split(',');
      return tags.map(t => (
        <Link
          to={`/publications/${this.props.publication.id}/tags/${t}`}
          key={`tag-${t.replace(' ', '-')}`}
          className={s.articleTag}
        >
          {t}
        </Link>
      ));
    }
    return <span />;
  }

  // renderAdsBannerSection() {
  //   // eslint-disable-next-line react/prop-types
  //   const ads = this.props.ads
  //     .filter(ad => ad.type === 'premium')
  //     .map(ad => {
  //       let { image_uid } = ad;
  //       const { image_url } = ad;
  //       image_uid =
  //         image_uid && image_uid.indexOf('https') === -1
  //           ? `https://dxfpracgmlczp.cloudfront.net/${image_uid}`
  //           : image_uid;
  //       return {
  //         imgSrc: image_uid,
  //         imgUrl: image_url,
  //       };
  //     });
  //   if (ads && ads.length > 0) {
  //     return (
  //       <div className={s.adsFixSection} style={{ left: this.state.adsLeft }}>
  //         <AdFixSection ads={ads} />
  //       </div>
  //     );
  //   }
  //   return <span />;
  // }

  renderAdsBannerSection(type, position, inLine) {
    const ads = this.props.ads
      .filter(ad => ad.type === type && ad.position === position)
      .map(ad => {
        let { image_uid } = ad;
        const { image_url } = ad;
        image_uid =
          image_uid && image_uid.indexOf('https') === -1
            ? `https://dxfpracgmlczp.cloudfront.net/${image_uid}`
            : image_uid;
        return {
          imgSrc: image_uid,
          imgUrl: image_url,
        };
      });
    if (ads && ads.length > 0) {
      return (
        <div
          className={inLine ? s.adsInlineSection : s.adsFixSection}
          style={inLine ? {} : { left: this.state.adsLeft }}
        >
          <AdFixSection ads={ads} />
        </div>
      );
    }
    return <span />;
  }

  render() {
    const {
      publications,
      tags,
      article,
      title,
      view_count,
      date,
    } = this.props.article;

    const sanitizedArticle = article.replace(
      /https?:\/\/(?:tradelinkmedia|fixeds3)\.s3\.amazonaws\.com\//g,
      'https://dxfpracgmlczp.cloudfront.net/',
    );
    const articleHalves = splitContent(sanitizedArticle, '</p>');

    const { lightboxImgUrl } = this.state;
    return (
      <div className={s.root}>
        <div className={s.leftSection}>
          <div className={`log-post-home ${s.container}`}>
            {this.renderAdsBannerSection('premium', 0)}
            <div className={`${s.newsMainSection}`}>
              <a
                className={`${s.publicationTag}`}
                href={`/publications/${publications}/`}
              >
                {COMPANY_FILTERS[publications]}
              </a>
              <span className={s.publicationDate}>
                {moment(date).format('DD MMM YYYY')}
              </span>
              <div className={s.newsTitle}>{title}</div>
              <div>{this.renderNewsListCarouselSection()}</div>
              <div className={`${s.subContainer}`}>
                <div className={`${s.tagArea}`}>
                  <i className="fa fa-tags" />
                  {this.renderTagLinks(tags)}
                </div>
                <div>
                  <CopyToClipboard
                    text={`https://${this.props.publication.short_name}.tradelinkmedia.biz${this.props.pathname}`}
                    onCopy={() => this.onCopied()}
                  >
                    <i
                      className={`font-15 fa color-black fa-link ${s.circleLink}`}
                    />
                  </CopyToClipboard>
                  <FacebookShareButton
                    url={`https://${this.props.publication.short_name}.tradelinkmedia.biz${this.props.pathname}`}
                    className={s.shareLink}
                  >
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                  <LinkedinShareButton
                    url={`https://${this.props.publication.short_name}.tradelinkmedia.biz${this.props.pathname}`}
                    className={s.shareLink}
                  >
                    <LinkedinIcon size={32} round />
                  </LinkedinShareButton>
                  <div
                    className={`${s.viewCountBox}`}
                  >{`Views: ${view_count}`}</div>
                </div>
              </div>
            </div>
            <div className={`${s.articleContainer}`}>
              <div dangerouslySetInnerHTML={{ __html: articleHalves[0] }} />
              <div>{this.renderAdsBannerSection('editorial', 1, true)}</div>
              <div dangerouslySetInnerHTML={{ __html: articleHalves[1] }} />
            </div>
          </div>
        </div>

        <div className={s.rightSection}>
          <div className={s.sectionTitleContainer}>
            <div className={s.sectionTitle}>More News</div>
          </div>
          <div className={s.squareNewsListContainer}>
            <NewsSideList items={this.props.allNews} />
          </div>
        </div>
        {lightboxImgUrl && (
          <ImageLightbox
            imageUrl={lightboxImgUrl}
            onClose={() => this.handleCloseImgLightbox()}
          />
        )}
      </div>
    );
  }
}

export default withStyles(s)(NewsRead);
